import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { volumeFeatureTags, volumes } from '../data/content';
export function Volumes() {
  return <section className="w-full bg-white px-5 pb-20 pt-4 sm:px-8" data-id="element-170" data-mp="183vkkneh6vui">
      <div className="mx-auto w-full max-w-5xl" data-id="element-171" data-mp="185q35v29ybvf">
        <Reveal data-id="element-172" data-mp="1c4yyv5gvkjtm">
          <h2 className="text-center font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl md:text-5xl" data-id="element-173" data-mp="1c6id6qiz0ksr">
            The <span className="text-brand-strong" data-id="element-174" data-mp="1zvuj9hj04cqu">10 Complete Volumes</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-175" data-mp="24s1t3leiq8e2">
          {volumes.map((volume, index) => <Reveal key={volume.tag} delay={index % 2 * 0.05} className="h-full" data-id="element-176" data-mp="1qwh9enqytm5l" data-mpi={index}>
              <article className="flex h-full flex-col rounded-card border border-navy/10 bg-white p-6 shadow-card sm:p-7" data-id="element-177" data-mp="1vrmuxlgggyt5">
                <div className="flex items-center justify-between gap-3" data-id="element-178" data-mp="fhkfp0ju68rw">
                  <span className="rounded-full bg-gold px-3 py-1 text-3xs font-bold uppercase tracking-widest text-navy" data-id="element-179" data-mp="kfm3fys7iw9p">
                    {volume.tag}
                  </span>
                  <span className="rounded-full bg-turf/10 px-3 py-1 text-xs font-semibold text-turf" data-id="element-180" data-mp="3jadfthz7mw7s">
                    {volume.age}
                  </span>
                </div>
                <h3 className="mt-4 font-display text-xl font-extrabold leading-snug tracking-tight text-navy" data-id="element-181" data-mp="3t685gx1uprk2">
                  {volume.title}
                </h3>
                <ul className="mt-5 space-y-2.5" data-id="element-182" data-mp="62juoxdv63nt">
                  {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5" data-id="element-183" data-mp="kr6mhykognvx">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-deep" aria-hidden="true" data-id="element-184" data-mp="ktamw6jdb4rg" />
                      <span className="text-sm leading-snug text-navy/80" data-id="element-185" data-mp="tsnvkwzo3pb4">{bullet}</span>
                    </li>)}
                </ul>
              </article>
            </Reveal>)}
        </div>

        <Reveal delay={0.08} data-id="element-186" data-mp="wrwh7hoz56tl">
          <div className="mt-10 rounded-card bg-tint px-6 py-8" data-id="element-187" data-mp="11saqf32bamt7">
            <ul className="flex flex-wrap items-center justify-center gap-3" data-id="element-188" data-mp="11qpsr4kpanr4">
              {volumeFeatureTags.map(tag => <li key={tag} className="rounded-full bg-white px-4 py-2 text-sm font-semibold text-navy shadow-card" data-id="element-189" data-mp="1bidkz7p308tn">
                  {tag}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}